<template>
	<div id="app">
		<main-nav />
		<status-message />
		<router-view />
		<flamingo />
		<grass-footer />
	</div>
</template>


<script>

	import MainNav from './components/MainNav.vue'
	import Footer from './components/Footer.vue'
	import StatusMessage from './components/StatusMessage'
	import Flamingo from './components/Flamingo.vue'

	export default {
		name: 'app',
		components: {
			'main-nav': MainNav,
			'grass-footer': Footer,
			'status-message': StatusMessage,
			'flamingo': Flamingo
		}
	}

</script>


<style lang="scss">

	body {
		font-family: 'Tw Cen MT', sans-serif;
		-webkit-font-smoothing: antialiased;
		-webkit-text-size-adjust: 100%;
		-moz-osx-font-smoothing: grayscale;
		background-color: $body-background-color;
		color: $body-text-color;
		margin-bottom: 0;
		padding-bottom: 0;
	}

	a {
		color: $link-color;
		text-decoration: none;

		&:hover {
			text-decoration: underline;
		}
	}

	.main-container {
		width: $page-width;
		max-width: $page-max-width;
		min-height: calc(100vh - #{$nav-height} - #{$footer-height} - 1px);
		position: relative;
		margin: 0 auto;
		padding: 30px 0 0 0;
		background-color: #fafaf2;
		box-shadow: 0 0 3px rgba(0, 0, 0, .15);

		@include mobile {
			width: $mobile-page-width;
			min-height: calc(100vh - #{$mobile-nav-height} - #{$footer-height} - 8px);
		}
	}

	.title {
		margin-top: 0;
		margin-bottom: 12px;
		padding-top: 0;
		font-family: 'MetallophileSp8W01', sans-serif;
		font-size: 35px;
		line-height: 35px;
		text-align: center;
	}


</style>
